import { css } from 'emotion'

export const paddingLeftRightMediumStyles = css`
  padding-left: 16px;
  padding-right: 16px;
`
